import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function PropostasImpostos() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Impostos</h1>
        <p className="text-muted-foreground">
          Gerencie os impostos das propostas
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Impostos</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Página em desenvolvimento</p>
        </CardContent>
      </Card>
    </div>
  );
}